<template>
	<div class="margin-left">
		<div class="detail text-left">
			<p class="fs22">{{title}}</p>
			<p class="margin-top-sm" v-html="body"></p>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				id:0,
				body:'',
				title:''
			};
		},
		created() {
			Bus.$on('feedbackdetail',data=>{
				this.id = data.id
				 this.getData()
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			getData(){
				this.ajax('get', '/api/feedback/getCateInfo',{
					id: this.id,
				},res => {
					console.log(res);
					if(res.status == 200){
						this.body = res.data.content
						this.title = res.data.title
					}else{
						
					}
				})
			}
		}
	}
</script>

<style>
	.detail{
		width: 910px;
		background: #FFFFFF;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 8px;
		padding: 41px 60px ;
	}
	.fs22{
		font-size: 22px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/feed/detail.vue